import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getItem } from '../localStorage';
import { apiService } from '../../service/api.service';
import { ThreeDotSpinner } from '../../components/loader';

const AUTH_STATES = {
  CHECKING: "checking",
  AUTHORIZED: "authorized",
  UNAUTHORIZED: "unauthorized",
};

function ProtectedRoute({ children }) {
  const [authState, setAuthState] = useState(AUTH_STATES.CHECKING);

  useEffect(() => {
    const token = getItem("admin_token");

    if (!token) {
      setAuthState(AUTH_STATES.UNAUTHORIZED);
      return;
    }

    let isMounted = true;

    apiService?.DashboardAPI?.usersCount()
      .then(() => {
        if (isMounted) {
          setAuthState(AUTH_STATES.AUTHORIZED);
        }
      })
      .catch((error) => {
        if (!isMounted) return;

        if (error?.response?.status === 401) {
          localStorage.clear();
          setAuthState(AUTH_STATES.UNAUTHORIZED);
        } else {
          setAuthState(AUTH_STATES.UNAUTHORIZED);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (authState === AUTH_STATES.CHECKING) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ThreeDotSpinner />
      </div>
    );
  }

  if (authState === AUTH_STATES.UNAUTHORIZED) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
